import React from 'react';
import { Theme, useMediaQuery } from '@material-ui/core';
import { FieldError } from '@spike/model';
import { GenericOrderItem } from 'components/Payments/SingleSale/SingleSale';
import { PriceField2 } from 'components/UI';
import { OrderizableTypes } from '@spike/order-model';

type ItemSubtotalProps = {
    item: GenericOrderItem;
    errors?: Array<FieldError>;
    calculating?: boolean;
    inputClassName?: string;
    onChange: (value?: number, name?: string) => void;
};

export const SingleSaleTableItemSubtotal: React.FC<ItemSubtotalProps> = props => {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const shouldShowTotal = isMobile || props.item.orderItem.orderizable.type !== OrderizableTypes.CUSTOM;

    return (
        <>
            {shouldShowTotal ? (
                `$${props.item.orderItem.total}`
            ) : (
                <PriceField2
                    scale={2}
                    precision={6}
                    className={props.inputClassName}
                    value={Number(props.item.orderItem.total)}
                    name={`${props.item.orderItem.uuid}_price`}
                    errors={props.errors}
                    onChange={props.onChange}
                />
            )}
        </>
    );
};
